import { BackgroundColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const Container = styled.div`
	margin-bottom: 20px;
`;

const DropdownContainer = styled.ul`
	padding: 14px 16px;
	min-width: 240px;
	background-color: ${BackgroundColors.Primary};
`;

const Item = styled.li`
	cursor: pointer;
	width: 100%;
	&:hover {
		background-color: ${BackgroundColors.PrimaryAlt};
	}
`;

export { Container, DropdownContainer, Item };
